import React, { useEffect, useState } from "react"
import { getMyPosts, deletePost } from "../api/weather"
import { useNavigate } from "react-router-dom"
import { Button, Card, Container } from "semantic-ui-react"
import UserBar from "./shared/UserBar"
import WeatherSnapshot from "./shared/WeatherSnapshot"

const UserPosts = (props) => {
	const { user, msgAlert } = props
	const [userPosts, setPosts] = useState(null)
	const navigate = useNavigate()
	let posts

	const removePost = (index) => {
		// console.log( userPosts[index],"index", index)
		deletePost(user, userPosts[userPosts.length - index - 1]._id, userPosts[userPosts.length -index- 1].reviews._id)
		.then(()=> {
			msgAlert({
				heading: 'Post deleted!',
				message: 'Removed!',
				variant: 'success'
			})
		})
		.then(() => getMyPosts(user).then((res) => {
				
			setPosts(res.data.reviews)
		}))
		.catch(() => {

		})
	}
	// console.log(userPosts._id)

	useEffect(() => {
		if (user === null) {
			navigate('/')
		} else {

			getMyPosts(user).then((res) => {
				
				setPosts(res.data.reviews)
			})
		}
	}, [navigate, user])
	

	if (userPosts !== null) {
		posts = userPosts.slice(0).reverse().map((post, index) => (
			
			<Card key={index}>
				<Card.Content>
					<Card.Header>
						{new Date(post.reviews.createdAt).toLocaleString(
							"en-us"
						)}
					</Card.Header>
				</Card.Content>
				<Card.Content>{post.reviews.review}</Card.Content>
				<Card.Content>
					<WeatherSnapshot weather={post} />
				</Card.Content>
				<Card.Content><Button circular color="red" onClick={()=>removePost(index)}>Delete</Button></Card.Content>
			</Card>
		))
		
	} else {
		posts = <h1>loading...</h1>
	}
	return (
        <Container as='nav'>
            <UserBar/>
			<h1>
                My posts
                </h1>
			<div className="user-posts">
				<Card.Group centered>{posts}</Card.Group>
			</div>
		</Container>
	)
}

export default UserPosts
